import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=289a560d&scoped=true&"
import script from "./programme.vue?vue&type=script&lang=js&"
export * from "./programme.vue?vue&type=script&lang=js&"
import style0 from "./programme.vue?vue&type=style&index=0&id=289a560d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a560d",
  null
  
)

export default component.exports